import React, { useRef } from 'react';
import PopupHeader from '../../../../components/PopupHeader';
import TagsInput from './TagsInput';
import styles from './TableMerge.module.css';

const TableMerge = props => {
  const { onClose } = props;
  const tagsInputRef = useRef(null);

  const selectedTags = tags => {
    // console.log(tags);
  };

  const mergeTable = () => {
    //merge table logic
  };

  const addTable = () => {
    tagsInputRef.current.addTags();
  };

  return (
    <div className={styles.container}>
      <PopupHeader onClose={onClose} />
      <TagsInput
        ref={tagsInputRef}
        selectedTags={selectedTags}
      />
      <div className={styles.btnsWrapper}>
        <button className={styles.btn} onClick={addTable}>ADD</button>
        <button className={styles.btn} onClick={mergeTable}>MERGE</button>
      </div>
    </div>
  );
};

export default TableMerge;
